import { useEffect, useState } from "react";
import LicenseService from "../../services/LicensesService";
import Checkbox from "../Checkbox/Checkbox";

export function LicenseFeaturesSelector({
   typeCode,
   values,
   onChange,
   isSubmitting = false,
   valueProperty = "code",
   onFeaturesLoaded,
   ...props
}) {
   const [features, setFeatures] = useState([]);

   async function fetchFeatures() {
      if (!typeCode) {
         setFeatures([]);
         return;
      }
      const response = await LicenseService.getTypeFeatures(typeCode);

      const validValues = response.data.map(feature => String(feature[valueProperty]));
      const normalizedValues = values?.map(value => String(value)) || [];
      const newValues = normalizedValues.filter(value => validValues.includes(value));
      if (newValues.length !== values?.length) {
         onChange(newValues);
      }

      setFeatures(response.data);
      onFeaturesLoaded?.(response.data);
   }

   useEffect(() => {
      fetchFeatures();
   }, [
      typeCode,
      valueProperty,
   ]);

   return (
      <div className={`flex justify-start ${props.type !== 'consulta' ? 'flex-wrap gap-6' : 'flex-col gap-2'}`}>
         {features?.map(feature => (
            <Checkbox
               key={feature.code}
               labelText={`${feature.name}`}
               name={`feature${feature.code}`}
               className="w-fit! inline-flex items-center flex-row-reverse gap-3"
               defaultChecked={
                  values?.find(value => String(value) === String(feature[valueProperty])) ||
                  false
               }
               checked={
                  values?.find(value => String(value) === String(feature[valueProperty])) ||
                  false
               }
               onChange={({ target }) => {
                  const featureValue = String(feature[valueProperty]);
                  if (!target.checked) {
                     onChange(values?.filter(value => String(value) !== featureValue));
                  } else {
                     const set = new Set(values?.map(value => String(value)) || []);
                     set.add(featureValue);
                     onChange([...set]);
                  }
               }}
               required={false}
               disabled={props.type === "consulta" || isSubmitting}
            />
         ))}
         {props.error && (
            <span className="error-message w-full">{props.error}</span>
         )}
      </div>
   );
}